import { useState, useEffect } from "react";

const useMySubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMySubscription = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/packages/my-subscription`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('No active subscription found');
        }
        throw new Error('Failed to fetch subscription details');
      }

      const data = await response.json();
      setSubscription(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMySubscription();
  }, []);

  const refetch = () => {
    fetchMySubscription();
  };

  return {
    subscription,
    loading,
    error,
    refetch
  };
};

export default useMySubscription; 